import { BaseProps } from '../common/props';
import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { cs } from 'date-fns/locale';
import { format } from 'date-fns';
import { useMemo, useState } from 'react';
import { Button } from '../button/Button';
import { Icon } from '../icon/Icon';
import { mcNavigateNext, mcNavigatePrev } from '@mc/react-ui-icons';
import { Divider } from '../divider/Divider';

export type MonthPickerProps = BaseProps & {
  value?: Date;
  onChange?: (date: Date) => void;
  endOfMonth?: boolean;
  locale?: Locale;
  // Voláno v případě, že se vybere konrkténí měsíc (nokoli při změně např. měsíce nebo roku)
  onClose?: () => void;
};

export const MonthPicker: React.FC<MonthPickerProps> = ({
  value,
  className,
  locale = cs,
  onClose,
  onChange,
  endOfMonth,
  children,
  ...other
}) => {
  const today = useMemo(() => {
    let v = new Date();
    v.setHours(0, 0, 0, 0);
    return v;
  }, []);

  const [year, setYear] = useState<number>(
    value ? value.getFullYear() : today.getFullYear()
  );

  const months = useMemo(() => {
    const list: Date[] = [];
    for (let a = 0; a < 12; a++) {
      const dt = new Date(year, a, 1);
      list.push(dt);
    }

    return list;
  }, [year]);

  const handleSelectMonth = (date: Date) => {
    let nd = new Date(date.getTime());

    if (endOfMonth) {
      nd.setMonth(nd.getMonth() + 1);
      nd.setDate(0);
    } else {
      nd.setDate(1);
    }

    onChange?.(nd);
    onClose?.();
  };

  const handleChangeYear = (year: number) => {
    setYear(year);
  };

  return (
    <div className={classNames(className, Classes.MONTH_PICKER)} {...other}>
      <div className={Classes.MONTH_PICKER_HEADER}>
        <Button
          style={'link'}
          icon={<Icon fixedWidth icon={mcNavigatePrev} />}
          onClick={() => handleChangeYear(year - 1)}
          dataTest={'prev-year'}
        ></Button>
        <div className={Classes.MONTH_PICKER_HEADER_YEAR}>{year}</div>
        <Button
          style={'link'}
          icon={<Icon fixedWidth icon={mcNavigateNext} />}
          onClick={() => handleChangeYear(year + 1)}
          dataTest={'next-year'}
        ></Button>
      </div>
      <Divider horizontal />
      <div className={Classes.MONTH_PICKER_MONTHS}>
        {months.map((month, monthIndex) => {
          const label = format(month, 'LLLL', { locale });
          return (
            <div
              key={label}
              className={classNames(Classes.MONTH_PICKER_MONTH, {
                [Classes.MONTH_PICKER_MONTH_TD]:
                  today.getMonth() === monthIndex &&
                  today.getFullYear() === year,
                [Classes.ACTIVE]:
                  monthIndex === value?.getMonth() &&
                  year === value?.getFullYear(),
              })}
              onClick={() => handleSelectMonth(new Date(year, monthIndex, 1))}
            >
              {label}
            </div>
          );
        })}
      </div>
    </div>
  );
};
